import { Button, TextField } from '@material-ui/core'
import React from 'react'
import { useForm, Controller } from 'react-hook-form'

type Inputs = {
  comment: string
}

const AddComment = ({ onCreate }: any) => {
  const { handleSubmit, errors, control, reset } = useForm<Inputs>()

  const onSubmit = (data: Inputs) => {
    if (!data.comment) return
    onCreate(data.comment)
    reset({
      comment: '',
    })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="AddComment">
      <Controller
        as={TextField}
        multiline
        control={control}
        rules={{ required: true }}
        defaultValue=""
        variant="outlined"
        margin="normal"
        fullWidth
        label="Comment"
        autoComplete="off"
        type="text"
        name="comment"
        placeholder="Comment"
        error={!!errors.comment}
        helperText={!!errors.comment && 'Your comment seems to be empty.'}
      />
      <Button type="submit" value="Comment" color="primary" variant="contained">
        Add Comment
      </Button>
    </form>
  )
}

export default AddComment
